import Box from '@mui/material/Box';
import { MobileCenteredLayout } from '@/components/MobileCenteredLayout/MobileCenteredLayout';
import { WelcomeFooter } from '@/components/WelcomeFooter/WelcomeFooter';
import { ErrorActions } from '@/Pages/Error/components/ErrorActions';
import { ErrorCode } from '@/Pages/Error/components/ErrorCode';
import { ErrorHeader } from '@/Pages/Error/components/ErrorHeader';
import { ErrorIcon } from '@/Pages/Error/components/ErrorIcon';
import { useErrorPage } from '@/Pages/Error/hooks/useErrorPage';
import '@/Pages/Error/ErrorPage.sass';

export function ErrorPage(): JSX.Element {
  const {
    errorType,
    title,
    description,
    errorCode,
    showRetry,
    isRetrying,
    handleRetry,
    handleHome,
    handleSupport,
  } = useErrorPage();

  return (
    <MobileCenteredLayout>
      <Box component="main" className="error-page" data-testid="error-page">
        <Box className="error-page__content">
          <ErrorIcon errorType={errorType} />
          <ErrorHeader title={title} description={description} />
          <ErrorCode errorCode={errorCode} />
        </Box>
        <Box className="error-page__actions">
          <ErrorActions
            showRetry={showRetry}
            isRetrying={isRetrying}
            onRetry={handleRetry}
            onHome={handleHome}
            onSupport={handleSupport}
          />
        </Box>
        <WelcomeFooter />
      </Box>
    </MobileCenteredLayout>
  );
}
